/**
* Created by kongwm.kong on 2017/7/24.
*/
<template>
    <div class="layout_n">
        <div class="net_management_wrap">
            <div class="search_wrap clearfix">
<!--                <div class="add_product">-->
<!--                    <router-link class="btn btn-bg-def" to="/net/0/0">新增净值<span>+</span></router-link>-->
<!--                </div>-->
                <div class="clearfix right" v-show="isJoined==1">
                    <div class="net-wrap left">
                        <input type="text" v-model="netName" placeholder="基金简称">
                    </div>
                    <div class="search left">
                        <span>净值日期起</span>
                        <date-picker class="date-time" :clear-button="true" language="zh" :format="dataPicker.format" v-model="dateStart" :input-class="dataPicker.input"></date-picker>
                        <span>止</span>
                        <date-picker class="date-time" :clear-button="true"  language="zh"  :format="dataPicker.format" v-model="dateEnd" :input-class="dataPicker.input"></date-picker>
                        <button class="search-btn" @click="setSearch">搜索</button>
                    </div>
                </div>
            </div>
            <div class="submenu_wrap">
                <div :class="{'menu-item':true,'active':item1}" @click="joined">已加入净值</div>
                <div :class="{'menu-item':true, 'active':item2}" @click="joining">待加入净值</div>
            </div>
            <net-table :isJoined="isJoined" :isSearch="isSearch" :noParams="noParams" :netName="netName" :dateStart="dateStart" :dateEnd="dateEnd"></net-table>
        </div>
    </div>
</template>
<script>
//    import datePicker from 'vuejs-datepicker';
    import netTable from './net_table';
    import datePicker from '../../components/middleware/Datepicker';

    export default {
        components:{
            datePicker,
            netTable
        },
        data(){
            return {
                item1: true,
                item2: false,
                noParams: true,
                netName: '',
                dateStart:'',
                dateEnd:'',
                isSearch:1,
                first: 0,
                dataPicker: {
                    format: 'yyyy-MM-dd',
                    input: 'date-input',
                }
            }
        },
        computed: {
            isJoined(){
                if(this.first ){
                    this.first = 0;
                } else {
                    this.noParams = true;
                }
                if(this.item1){
                    return 1;
                }else {
                    return 2;
                }
            }
        },
        created(){
//            this.$store.commit('getLoginInfo');
            this.initNet();
        },
        watch:{
          $route(){
              this.getQueryName();
          }
        },
        methods:{
            initNet(){
                this.getItem();
                this.getQueryName();
            },
            getItem(){
                let item = this.$route.query.item;
                if(item==2){
                    this.joining();
                }
            },
            getQueryName(){
                let name = this.$route.query.name;
                if(name){
                    this.first ++ ;
                    this.netName = name;
                    this.setSearch();
                }
            },
            setSearch(){
                this.noParams = false;
                this.first ++ ;
                this.isSearch = (this.isSearch === 1) ? 2 : 1;
            },
            joining(){
                this.item1 = false;
                this.item2 = true;
            },
            joined(){
                this.item2 = false;
                this.item1 = true;
            },
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    @import '../../assets/css/common/center';
    .pagination {
    }
    .page-item {
    }
    .vdp-datepicker .input{
        width:140px;
        height: 40px;
        font-size: 16px;
        line-height:1;
        padding: 7px 0;
    }
    .layout_n{
        @include mainMar;
        .net_management_wrap{
            padding: 50px 38px 230px;
            @include bgff;
            .search_wrap{
                min-height: 43px;
                input{
                    width:140px;
                    height:38px;
                    font-size: 16px;
                    line-height:1;
                    padding: 7px 0;
                    text-indent: 10px;
                }
                .add_product{
                    width:168px;
                    position: relative;
                    float: left;
                    .btn{
                        position: absolute;
                        top:0;
                        left:0;
                        bottom: 0;
                        right:0;
                        color:#fff;
                        background: $btn_408;
                        height:46px;
                        width:168px;
                        font-size: 18px;
                        letter-spacing: -0.43px;
                        line-height: 46px;
                        text-indent: 38px;
                        &:active, &:hover{
                            span{
                                color:$btn_ffa;
                            }
                        }
                        span{
                            display: inline-block;
                            width:20px;
                            height:20px;
                            border-radius: 50%;
                            background: #fff;
                            color:$btn_408;
                            font-weight: bold;
                            vertical-align: middle;
                            line-height: 1;
                            text-indent: 3px;
                            margin-left:5px;
                        }
                    }
                }
                .net-wrap{
                    margin-top:3px;
                    margin-left:230px;
                    width:140px;
                    height:40px;
                    border: 1px solid $border_bfb;
                }
                .search{
                    span{
                        margin: 0  8px ;
                        input {
                            border: 1px solid $border_bfb;
                        }
                    }
                    .date-time{
                        display: inline-block;
                        vertical-align: middle;
                        width:140px;
                        height: 40px;
                        border: 1px solid $border_bfb;

                    }
                    .search-btn{
                        position: relative;
                        top: 3px;
                        width: 88px;
                        height:40px;
                        margin-left:30px;
                        text-align: center;
                        line-height: 40px;
                        color:#fff;
                        font-size:18px;
                        background: $btn_408;
                    }
                }
            }
            /*submenu_wrap*/
            .submenu_wrap{
                margin: 50px 0;
                @include subMenu;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/netMana/index.vue